import React, { createContext, useContext, useState } from 'react';

const AccountingModeContext = createContext();

export const useAccountingMode = () => {
  const context = useContext(AccountingModeContext);
  if (!context) {
    throw new Error('useAccountingMode must be used within AccountingModeProvider');
  }
  return context;
};

export const AccountingModeProvider = ({ children }) => {
  const [mode, setMode] = useState('total'); // 'declared' (A) or 'total' (A+B)

  const toggleMode = () => {
    setMode(prev => prev === 'declared' ? 'total' : 'declared');
  };

  const isDeclaredMode = mode === 'declared';
  const isTotalMode = mode === 'total';

  return (
    <AccountingModeContext.Provider value={{ mode, setMode, toggleMode, isDeclaredMode, isTotalMode }}>
      {children}
    </AccountingModeContext.Provider>
  );
};
